module.exports = __webpack_public_path__ + "img/bg-ticket.996f2edb.png";